import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { FormsModule, FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { AsyncPipe } from "@angular/common";

@Component({
	selector: "autocomplete-search",
	templateUrl: "autocomplete-search.component.html",
	styleUrl: "autocomplete-search.component.css",
	standalone: true,
	imports: [
		MatSelectModule,
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatAutocompleteModule,
		ReactiveFormsModule,
		AsyncPipe,
	],
})
export class AutocompleteSearchComponent implements OnInit {
	@Input() options: string[];
	@Input() name: string;
	@Input() selected: string | null;
	@Output() selectedEmit = new EventEmitter<string>();

	formControl = new FormControl("");
	filteredOptions: Observable<string[]>;

	ngOnInit() {
		this.formControl.setValue(this.selected);
		this.filteredOptions = this.formControl.valueChanges.pipe(
			startWith(""),
			map((value) => this._filter(value || "")),
		);
	}

	private _filter(value: string): string[] {
		const filterValue = value.toLowerCase();

		return this.options.filter((option) =>
			option.toLowerCase().includes(filterValue),
		);
	}

	onFocusOut(event: any) {
		let selected =
			this.formControl.value === null ? "" : this.formControl.value;
		this.selectedEmit.emit(selected);
	}
}
